import { IFormActualsTargetsSettings } from 'legacy/lut/classes/models/partner360/IFormActualsTargetsSettings'

import { IJBPPlanningItem } from '../../models/IJBPPlanning'
import { PLANNING_BY_FY_FQ } from '../config'
import { IPartnersCompleteness } from '../models/IPartnersCompleteness'

interface IGetCompletenessItem {
  formats: IFormActualsTargetsSettings[]
  settingsIndex: number
  items: IJBPPlanningItem[]
  fy: number
  isSoB: boolean
}

export const getCompletenessItem = ({
  formats,
  settingsIndex,
  items,
  fy,
  isSoB,
}: IGetCompletenessItem): IPartnersCompleteness => {
  let programType: string = ''
  let partnersCount: number = 0
  let partnersCountNotAcknowledged: number = 0
  let partnersCountAcknowledged: number = 0
  let partnersCompleted: number = 0
  let partnersCompletedAcknowledged: number = 0
  let partnersNotCompleted: number = 0
  let partnersNotCompletedAcknowledged: number = 0
  let partnersNotFullyCompleted: number = 0
  let reportGuid: string = ''

  if (settingsIndex < formats.length) {
    const setting = formats[settingsIndex]

    // Items filtered on Top level by: PartnerId, IsActuals, IsTarget, IsQuota
    const sourceData = items.filter(
      (el) =>
        el.ProgramTypes === setting.ProgramType &&
        el.Category === setting.Category &&
        el.SubCategory === setting.SubCategory &&
        el.L3Category === setting.L3Category &&
        el.FYear === fy &&
        el.FQuarter === PLANNING_BY_FY_FQ
    )
    if (sourceData.length >= 1) {
      programType = setting.ProgramType

      partnersCount = sourceData[0].PartnersCount
      partnersCountAcknowledged = sourceData[0].PartnersCountAcknowledged
      partnersCountNotAcknowledged = sourceData[0].PartnersCountNotAcknowledged

      if (isSoB) {
        partnersCompleted = sourceData[0].SoBPartnersCompleted
        partnersCompletedAcknowledged = sourceData[0].SoBPartnersCompletedAcknowledged
        partnersNotCompleted = sourceData[0].SoBPartnersNotCompleted
        partnersNotCompletedAcknowledged = sourceData[0].SoBPartnersNotCompletedAcknowledged
        partnersNotFullyCompleted = sourceData[0].SoBPartnersNotFullyCompleted
      } else {
        partnersCompleted = sourceData[0].PartnersCompleted
        partnersCompletedAcknowledged = sourceData[0].PartnersCompletedAcknowledged
        partnersNotCompleted = sourceData[0].PartnersNotCompleted
        partnersNotCompletedAcknowledged = sourceData[0].PartnersNotCompletedAcknowledged
        partnersNotFullyCompleted = sourceData[0].PartnersNotFullyCompleted
      }

      reportGuid = sourceData[0].ReportGUID
    } else {
      // error in data
    }
  }

  return {
    programType,

    partnersCount,
    partnersCountAcknowledged,
    partnersCountNotAcknowledged,

    partnersCompleted,
    partnersCompletedAcknowledged,
    partnersNotCompleted,
    partnersNotCompletedAcknowledged,
    partnersNotFullyCompleted,

    reportGuid,
  }
}
